import { createSlice } from "@reduxjs/toolkit";

export const appSlice = createSlice({
  name: "app",
  initialState: { showCreditsDialog: false },
  reducers: {
    setShowCreditsDialog: (state, action) => {
      state.showCreditsDialog = action.payload;
    },
  },
});

export const { setShowCreditsDialog } = appSlice.actions;

export default appSlice.reducer;
